import { Component, Input } from "@angular/core";
import { NgStyle } from "@angular/common";

@Component({
  selector: "app-title",
  templateUrl: "./title.component.html",
  styleUrls: ["./title.component.scss"],
  imports: [NgStyle],
  standalone: true,
})
export class TitleComponent {
  @Input() color = "dark-shade";

  @Input() weight = "700";

  @Input() size = "";

  @Input() flex = false;
}
